import TextField from "../../../components/fields/textField/TextField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import { ExercicioService } from "../../../services/ExercicioService";
import { AcaoService } from "../../../services/AcaoService";
import { SecaoService } from "../../../services/SecaoService";
import { GrupoService } from "../../../services/GrupoService";
import { ElementoItemService } from "../../../services/ElementoItemService";
import { IpgService } from "../../../services/IpgService";
import { IpuService } from "../../../services/IpuService";
import { PpagService } from "../../../services/PpagService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";

export default {
    components: {
        TextField,
        TextAreaField,
        SelectField,
        Breadcrumb
    },
    name: "CriarPpag",
    props: {
        activeModal: {
            default: false,
            type: Boolean,
        }
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de PPAGs',
                disabled: false,
                href: '/gerenciar-ppag'
            },
            {
                text: 'Cadastro de PPAG',
                disabled: true
            }
        ],
        ppag: {
            exercicio: '',
            codigo_ppag: '',
            detalhamento: '',
            gerencia: '',
            valor: '',
            acao_id: '',
            grupo_id: '',
            ipg_id: '',
            ipu_id: '',
            secao_id: '',
            elemento_item_id: '',
            ativo: true 
        },
        exerciciosOptions: [],
        acoesOptions: [],
        secoesOptions: [],
        ipgsOptions: [],
        ipusOptions: [],
        gruposOptions: [],
        elementosItensOptions: [],
        loading: false,
        snackbar: {
            show: false,
            message: '',
            color: 'success',
            timeout: 4000
        },
        validationRules: {
            required: [
                v => !!v || 'Este campo é obrigatório'
            ],
            numeric: [
                v => !!v || 'Este campo é obrigatório',
                v => !isNaN(v) || 'Deve ser um número válido'
            ],
            numericOnly: v => /^\d*$/.test(v) || 'Apenas números são permitidos'
        }
    }),
    created() {
        this.listarExerciciosSelect();
        this.listarAcoesSelect();
        this.listarSecoesSelect();
        this.listarElementosItensSelect();
        this.listarGruposSelect();
        this.listarIpgsSelect();
        this.listarIpusSelect();
    },
    watch: {
        activeModal(val) {
            if (val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.ppag.exercicio = '';
            this.ppag.codigo_ppag = '';
            this.ppag.detalhamento = '';
            this.ppag.gerencia = '';
            this.ppag.valor = '';
            this.ppag.acao_id = '';
            this.ppag.grupo_id = '';
            this.ppag.ipg_id = '';
            this.ppag.ipu_id = '';
            this.ppag.secao_id = '';
            this.ppag.elemento_item_id = '';
            this.ppag.ativo = true; 
            
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },

        submitForm() {
            const isValid = this.$refs.form.validate();
            
            if (!isValid) {
                this.showMessage('Por favor, preencha todos os campos obrigatórios', 'error');
                return;
            }
            
            this.salvarPpag();
        },

        async salvarPpag() {
            try {
                this.loading = true;

                const formData = new FormData();

                // Adiciona todos os campos obrigatórios
                formData.append("exercicio", this.ppag.exercicio);
                formData.append("codigo_ppag", this.ppag.codigo_ppag);
                formData.append("gerencia", this.ppag.gerencia);
                formData.append("valor", this.ppag.valor);
                formData.append("acao_id", this.ppag.acao_id);
                formData.append("ipg_id", this.ppag.ipg_id);
                formData.append("ipu_id", this.ppag.ipu_id);
                formData.append("secao_id", this.ppag.secao_id);
                formData.append("grupo_id", this.ppag.grupo_id); // Agora obrigatório
                formData.append("elemento_item_id", this.ppag.elemento_item_id);
                formData.append("ativo", this.ppag.ativo ? 1 : 0);

                // Adiciona detalhamento se tiver valor
                if (this.ppag.detalhamento && this.ppag.detalhamento.trim() !== '') {
                    formData.append("detalhamento", this.ppag.detalhamento.trim());
                }

                // Debug: Verificar o que está sendo enviado
                console.log('Dados enviados:');
                for (let [key, value] of formData.entries()) {
                    console.log(`${key}: ${value}`);
                }

                const response = await PpagService.store(formData);

                if (response) {
                    this.resetForm();
                    this.$emit('ppag-salvo');
                } else {
                    this.showMessage('Erro ao salvar PPAG. Tente novamente.', 'error');
                }

            } catch (error) {
                console.error('Erro ao salvar PPAG:', error);
                this.showMessage('Erro interno. Contate o administrador.', 'error');
            } finally {
                this.loading = false;
            }
        },

        cancelar() {
            this.$router.push('/gerenciar-ppag');
        },

        showMessage(message, type = 'success') {
            this.snackbar.message = message;
            this.snackbar.color = type;
            this.snackbar.show = true;
        },

        async close() {
            this.loading = false;
            this.resetForm();
            this.$emit("on-close");
        },

        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },

        async listarAcoesSelect() {
            try {
                const response = await AcaoService.select();
    
                if (response) {
                    this.acoesOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_acao} - ${el.descricao_acao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter as ações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar as ações:', error);
            }
        },

        async listarIpusSelect() {
            try {
                const response = await IpuService.select();
                if (response) {
                    this.ipusOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipu} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os IPUs.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os IPUs:', error);
            }
        },

        async listarIpgsSelect() {
            try {
                const response = await IpgService.select();
                if (response) {
                    this.ipgsOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipg} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os IPGs.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os IPGs:', error);
            }
        },

        async listarGruposSelect() {
            try {
                const response = await GrupoService.select();
                if (response) {
                    this.gruposOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_grupo} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os grupos.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os grupos:', error);
            }
        },

        async listarSecoesSelect() {
            try {
                const response = await SecaoService.select();
                if (response) {
                    this.secoesOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_secao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter as seções.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar as seções:', error);
            }
        },

        async listarElementosItensSelect() {
            try {
                const response = await ElementoItemService.select();
                if (response) {
                    this.elementosItensOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento_item} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os elementos/itens.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os elementos/itens:', error);
            }
        },

        // Métodos para validação numérica do código PPAG
        onlyNumbers(event) {
            const charCode = event.which ? event.which : event.keyCode;
            
            // Bloquear explicitamente pontos e outros caracteres especiais
            if (charCode === 190 || charCode === 110 || charCode === 188 || charCode === 46) {
                event.preventDefault();
                return false;
            }
            
            // Permitir apenas números (48-57) e teclas especiais de navegação
            if (charCode < 48 || charCode > 57) {
                // Permitir apenas teclas especiais: backspace (8), tab (9), enter (13), setas (37-40)
                if (charCode !== 8 && charCode !== 9 && charCode !== 13 && 
                    charCode !== 37 && charCode !== 38 && charCode !== 39 && charCode !== 40) {
                    event.preventDefault();
                    return false;
                }
            }
            
            return true;
        },

        // Método para filtrar entrada e manter apenas números
        onNumericInput(fieldName, value) {
            const numericValue = value.replace(/[^0-9]/g, '');
            this.ppag[fieldName] = numericValue;
        },

        // Método para interceptar colagem e filtrar apenas números
        onPaste(event) {
            event.preventDefault();
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            const numericOnly = pastedText.replace(/[^0-9]/g, '');
            this.ppag.codigo_ppag = numericOnly;
        },
    },
};
